export const WS_URL = import.meta.env.VITE_WS_HOST;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
